export default function() {
  window.modalManager.idModalMap.forEach(modal => {
    const iframe = modal.element.querySelector('iframe');
    const htmlvideo = modal.element.querySelector('video');
    const focusInput = modal.element.querySelector('.js-modal-focus');

    if (iframe && modal.element.classList.contains('modal--video')) {
      const { src } = iframe;
      const srcAutoplay = `${src}${src.includes('?') ? '&' : '?'}autoplay=1&rel=0`;

      modal.on('show', () => {
        setTimeout(() => {
          iframe.src = srcAutoplay;
        }, 60);
      });

      modal.on('before-hide', () => {
        window.setTimeout(() => {
          iframe.src = src;
        }, 500);
      });
    }

    if (htmlvideo && modal.element.classList.contains('modal--video')) {
      modal.on('show', () => {
        setTimeout(() => {
          htmlvideo.autoplay = true;
          htmlvideo.play();
        }, 100);
      });

      modal.on('before-hide', () => {
        window.setTimeout(() => {
          htmlvideo.pause();
        }, 500);
      });
    }

    if (focusInput) {
      modal.on('show', () => {
        setTimeout(() => {
          focusInput.focus({ preventScroll: true });
        }, 60);
      });
    }
  });
}
